/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoMemberDataMismatchDto
 */
export interface WebApiIntegrationsDtoMemberDataMismatchDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    customerNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    fullName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    mismatchedFields?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    oneFrontName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    externalName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    oneFrontEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    externalEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    oneFrontPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    externalPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    oneFrontAddress1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    externalAddress1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    oneFrontAddress2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    externalAddress2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    oneFrontCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    externalCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    oneFrontZipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberDataMismatchDto
     */
    externalZipCode?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoMemberDataMismatchDto interface.
 */
export function instanceOfWebApiIntegrationsDtoMemberDataMismatchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoMemberDataMismatchDtoFromJSON(json: any): WebApiIntegrationsDtoMemberDataMismatchDto {
    return WebApiIntegrationsDtoMemberDataMismatchDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoMemberDataMismatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoMemberDataMismatchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'customerNumber': !exists(json, 'customerNumber') ? undefined : json['customerNumber'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'mismatchedFields': !exists(json, 'mismatchedFields') ? undefined : json['mismatchedFields'],
        'oneFrontName': !exists(json, 'oneFrontName') ? undefined : json['oneFrontName'],
        'externalName': !exists(json, 'externalName') ? undefined : json['externalName'],
        'oneFrontEmail': !exists(json, 'oneFrontEmail') ? undefined : json['oneFrontEmail'],
        'externalEmail': !exists(json, 'externalEmail') ? undefined : json['externalEmail'],
        'oneFrontPhone': !exists(json, 'oneFrontPhone') ? undefined : json['oneFrontPhone'],
        'externalPhone': !exists(json, 'externalPhone') ? undefined : json['externalPhone'],
        'oneFrontAddress1': !exists(json, 'oneFrontAddress1') ? undefined : json['oneFrontAddress1'],
        'externalAddress1': !exists(json, 'externalAddress1') ? undefined : json['externalAddress1'],
        'oneFrontAddress2': !exists(json, 'oneFrontAddress2') ? undefined : json['oneFrontAddress2'],
        'externalAddress2': !exists(json, 'externalAddress2') ? undefined : json['externalAddress2'],
        'oneFrontCity': !exists(json, 'oneFrontCity') ? undefined : json['oneFrontCity'],
        'externalCity': !exists(json, 'externalCity') ? undefined : json['externalCity'],
        'oneFrontZipCode': !exists(json, 'oneFrontZipCode') ? undefined : json['oneFrontZipCode'],
        'externalZipCode': !exists(json, 'externalZipCode') ? undefined : json['externalZipCode'],
    };
}

export function WebApiIntegrationsDtoMemberDataMismatchDtoToJSON(value?: WebApiIntegrationsDtoMemberDataMismatchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'customerNumber': value.customerNumber,
        'fullName': value.fullName,
        'mismatchedFields': value.mismatchedFields,
        'oneFrontName': value.oneFrontName,
        'externalName': value.externalName,
        'oneFrontEmail': value.oneFrontEmail,
        'externalEmail': value.externalEmail,
        'oneFrontPhone': value.oneFrontPhone,
        'externalPhone': value.externalPhone,
        'oneFrontAddress1': value.oneFrontAddress1,
        'externalAddress1': value.externalAddress1,
        'oneFrontAddress2': value.oneFrontAddress2,
        'externalAddress2': value.externalAddress2,
        'oneFrontCity': value.oneFrontCity,
        'externalCity': value.externalCity,
        'oneFrontZipCode': value.oneFrontZipCode,
        'externalZipCode': value.externalZipCode,
    };
}

